<template>
  <div class="wearther-display">
    <div style="justify-items: center;" v-if="weatherLoading === true">天气加载中......</div>
    <div v-else>
        <div>{{ weather.city }}</div>
        <SkyconComponent v-if="iconCondition" :condition="iconCondition" color="CornflowerBlue" size="40" />
        <div v-if="iconCondition" class="flex-center font-22" style="margin-left: 6px;">
         <span style="color: MediumTurquoise; margin-right: 6px;">{{ weather.temperature }}℃ </span>
         <span>{{ weather.weather }}</span>
        </div>
    </div>
  </div>
</template>

<script>

import SkyconComponent from 'vue-skycons';
import { getLocalPosition, getWeather } from '@/api/gdweather';

export default {
  name: 'Weather',
  components: {
    SkyconComponent
  },
  data() {
    return {
      // 天气数据
      weather: {},
      iconCondition: null,
      weatherLoading: false
    };
  },
  mounted(){
    try{
      this.getLocationInfo();
    }catch{
      this.weather = {}
    }
  },
  methods: {
    // 获取用户位置信息
    async getLocationInfo() {
      const resp = await getLocalPosition({});
      if(resp.data === null){
        this.weatherLoading = true;
        return;
      }
      this.getWeather(resp.data.adcode);
    },
    // 获取天气详情
    async getWeather(adcode) {
    const resp = await getWeather({cityCode: adcode});
    if(resp.data === null){
        this.weatherLoading = true;
        return;
      }
      this.weather = resp.data.lives[0];
      this.iconCondition = this.setWeatherIcon(resp.data.lives[0]?.weather);
    },
    // 设置icon
    setWeatherIcon(weather) {
      // 只处理了基础的天气，可以继续精细化处理
      if (weather === '晴') {
        return 'clear-day';
      } else if (weather.includes('云')) {
        return 'partly-cloudy-day';
      } else if (weather.includes('风')) {
        return 'wind';
      } else if (weather.includes('雨')) {
        return 'rain';
      } else if (weather.includes('雪')) {
        return 'snow';
      } else if (weather.includes('雾')) {
        return 'fog';
      }
      return 'cloudy';
    },
  },
};
</script>

<style scoped>
.wearther-display {
  font-family: FZShuTi;
  font-size: 26px;
  font-weight: 600;
  text-align: center;
  color: hsl(207, 98%, 20%, 1);
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  padding: 10px;
    /* iOS风格毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.4); /* 提高透明度 */
  backdrop-filter: blur(20px) saturate(180%); /* 增加模糊和饱和度 */
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  /* 添加微妙的边框效果增强层次感 */
  border: 1px solid rgba(255, 255, 255, 0.3);
  /* 更柔和的阴影 */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  
  transition: all 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
}

.wearther-display:hover {
  transform: translateY(-8px) scale(1.02);
  /* 悬停时更明显的毛玻璃效果 */
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(25px) saturate(200%);
  -webkit-backdrop-filter: blur(25px) saturate(200%);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.15), 0 10px 10px rgba(0, 0, 0, 0.1);
}
</style>